import { Path, Svg } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const TrialPromoOfferMissing = withDefaultIconProps({ height: 46, width: 45 }, ({ color: _, ...rest }) => (
  <Svg {...rest} viewBox="0 0 46 45">
    <Path
      d="M29.43 7.27C31.35 8.08 33.08 9.25 34.56 10.73C36.05 12.21 37.21 13.94 38.02 15.86C38.86 17.85 39.29 19.97 39.29 22.15C39.29 24.32 38.86 26.44 38.02 28.43C37.21 30.35 36.05 32.08 34.56 33.56C33.08 35.05 31.35 36.21 29.43 37.02C27.44 37.86 25.32 38.29 23.15 38.29C20.97 38.29 18.85 37.86 16.86 37.02C14.94 36.21 13.21 35.05 11.73 33.56C10.25 32.08 9.08 30.35 8.27 28.43C7.43 26.44 7 24.32 7 22.15C7 19.97 7.43 17.85 8.27 15.86C9.08 13.94 10.25 12.21 11.73 10.73C13.21 9.25 14.94 8.08 16.86 7.27C18.85 6.43 20.97 6 23.15 6C25.32 6 27.44 6.43 29.43 7.27Z"
      fill="#E0E0E0"
      opacity="0.5"
    />
    <Path
      d="M30.16 21.35H24.41V15.61C24.41 14.97 23.9 14.46 23.27 14.46C22.63 14.46 22.12 14.97 22.12 15.61V21.35H16.37C15.74 21.35 15.23 21.87 15.23 22.5C15.23 23.13 15.74 23.65 16.37 23.65H22.12V29.39C22.12 30.03 22.63 30.54 23.27 30.54C23.9 30.54 24.41 30.03 24.41 29.39V23.65H30.16C30.79 23.65 31.31 23.13 31.31 22.5C31.31 21.87 30.79 21.35 30.16 21.35Z"
      fill="#999999"
    />
  </Svg>
));
